export default __webpack_public_path__ + "static/media/ic-reports-white.8c12b3ac.svg";